import { HttpException } from '@/utils/api/api-client';

export enum SearchErrorType {
  NOT_FOUND = 'notFound',
  SERVER = 'server',
  OFFLINE = 'offline',
}

export type RetryableSearchError = SearchErrorType.SERVER | SearchErrorType.OFFLINE;

export function isRetryableSearchError(type: SearchErrorType | null): type is RetryableSearchError {
  return type === SearchErrorType.SERVER || type === SearchErrorType.OFFLINE;
}

const networkErrorNames = ['TimeoutError', 'AbortError'];

function getErrorName(error: unknown): string | undefined {
  if (typeof error !== 'object' || error === null || !('name' in error)) {
    return undefined;
  }

  return String((error as { name: unknown }).name);
}

function isOffline(): boolean {
  return typeof navigator !== 'undefined' && navigator.onLine === false;
}

export function classifySearchError(error: unknown): SearchErrorType {
  if (error instanceof HttpException) {
    return error.status === 404 ? SearchErrorType.NOT_FOUND : SearchErrorType.SERVER;
  }

  const name = getErrorName(error);

  if (name && networkErrorNames.includes(name)) {
    return SearchErrorType.OFFLINE;
  }

  if (error instanceof TypeError || isOffline()) {
    return SearchErrorType.OFFLINE;
  }

  return SearchErrorType.SERVER;
}
